import * as Sections from 'component/sections/home';
import SimpleContent from 'component/sections/common/simple-content-base';
import ImageGraphicSplit from 'component/image-graphic-split';
import Footer from 'component/footer';
import Copy from '@resn/gozer-core/copy';

import { COLORS } from 'core/constants';

// import env from 'core/env';
// import { getRoute } from 'utils/get-pages';

const features = [
    {
        customImage: {
            class: ImageGraphicSplit,
            options: {
                graphicId: 'feature1Graphic',
                imgId: 'feature1Img',
            },
        },
    },
    { imgId: 'feature2Img' },
    { imgId: 'feature3Img' },
];

export default {
    sections: [
        {
            id: 'XS1Hero',
            class: Sections.XS1Promo,
        },

        {
            id: 'Hero',
            class: Sections.Hero,
        },

        ...features.map((feature, index) => {
            return {
                id: `feature-${index}`,
                class: SimpleContent, //index ? SimpleContent : Sections.HomeDiscoverXP1,
                options: {
                    subtitle: Copy.get(`home-module-${index + 1}-subtitle`),
                    title: Copy.get(`home-module-${index + 1}-title`),
                    body: Copy.get(`home-module-${index + 1}-paragraph`),
                    className: `home__feature--${index}`,
                    align: index % 2 ? 'right' : 'left',
                    bgColor: COLORS.OFF_WHITE,
                    highlightColor: COLORS.ORANGE,
                    parallax: true,
                    inverseColors: true,
                    // imgSrc: `${env.CDN}static/images/pages/home/feature-${index + 1}.png`,
                    ...feature,
                },
            };
        }),

        {
            id: 'Software',
            class: Sections.Software,
        },

        {
            id: 'Discover',
            class: Sections.HomeDiscoverXP1,
            options: {
                subtitle: Copy.get('home-module-7-subtitle'),
                title: Copy.get('home-module-7-title'),
                body: null,
                link: {
                    name: Copy.get('home-module-7-button'),
                    page: 'xp1',
                },
                align: 'right',
                className: 'homeDiscover',
                bgColor: COLORS.DARK_BLUE,
                highlightColor: COLORS.LIGHT_BLUE,

                customImage: {
                    class: ImageGraphicSplit,
                    options: {
                        graphicId: 'discoverGraphic',
                        imgId: 'discoverImg',
                    },
                },

                btnData: {
                    textColor: 'white',
                    bgColor: COLORS.ORANGE,
                },
            },
        },

        {
            id: 'Footer',
            class: Footer,
        },
    ],
};

export { features };
